import { DateTimeV2 } from '../DateTimeV2'

export type DateTimeRangeV2 = {
  startDateTime: DateTimeV2 | undefined
  endDateTime: DateTimeV2 | undefined
}

const isDateTimeV2OrUndefined = (value: unknown): boolean =>
  value === undefined || value instanceof Date

export const isDateTimeRangeV2 = (value: unknown): value is DateTimeRangeV2 =>
  typeof value === 'object' &&
  value !== null &&
  'startDateTime' in value &&
  'endDateTime' in value &&
  isDateTimeV2OrUndefined(value.startDateTime) &&
  isDateTimeV2OrUndefined(value.endDateTime)
